import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
          {aboutData.title}
        </h2>
        <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-10 max-w-2xl mx-auto">
          {aboutData.content}
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {aboutData.highlights.map((item) => (
            <div
              key={item.text}
              className="bg-background-50 rounded-xl p-5 border border-background-200/60"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mx-auto mb-3">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 font-medium leading-tight">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}